export default "__VITE_ASSET__DiMBa0Ui__"